import { z } from 'zod';

const isoDateTime = () => z.string().datetime({ offset: true });

export const expensePaymentMethodSchema = z.enum(['check', 'credit_card', 'cash']);

export const expenseSchema = z.object({
  id: z.string().uuid(),
  jobId: z.string().uuid(),
  categoryId: z.string().uuid(),
  // Deprecated legacy link — read-only, populated on pre-document-model rows.
  projectId: z.string().uuid().nullable(),
  // The project this expense belongs to, by name. See jobExpenses.projectName.
  projectName: z.string().nullable(),
  storeName: z.string().min(1),
  description: z.string().min(1),
  // Negative amounts represent refunds / returned materials.
  amount: z.number(),
  expenseDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Must be YYYY-MM-DD'),
  // The receipt, as a reference into the job's file store.
  fileId: z.string().uuid().nullable().optional(),
  paidDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).nullable(),
  paymentMethod: expensePaymentMethodSchema.nullable(),
  checkNumber: z.string().nullable(),
  reimburse: z.boolean(),
  createdBy: z.string().uuid(),
  createdAt: isoDateTime(),
  updatedAt: isoDateTime(),
});

// Writes carry the project by name, never by id: breakdown project ids belong
// to a single breakdown document and are re-minted on every copy, so an id
// written here could not be resolved against the job's active document later
// (and, before this, violated the legacy project_id foreign key outright).
export const expenseInputSchema = z.object({
  jobId: z.string().uuid(),
  categoryId: z.string().uuid(),
  projectName: z.string().min(1).nullable().optional(),
  storeName: z.string().min(1),
  description: z.string().min(1),
  // Negative amounts represent refunds / returned materials.
  amount: z.number(),
  expenseDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Must be YYYY-MM-DD'),
  // The receipt, as a reference into the job's file store.
  fileId: z.string().uuid().nullable().optional(),
  paidDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).nullable().optional(),
  paymentMethod: expensePaymentMethodSchema.nullable().optional(),
  checkNumber: z.string().nullable().optional(),
  reimburse: z.boolean().default(false).optional(),
  pendingReceiptId: z.string().uuid().optional(),
});

export const expenseUpdateSchema = z.object({
  categoryId: z.string().uuid().optional(),
  projectName: z.string().min(1).nullable().optional(),
  storeName: z.string().min(1).optional(),
  description: z.string().min(1).optional(),
  amount: z.number().optional(),
  expenseDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Must be YYYY-MM-DD').optional(),
  // The receipt, as a reference into the job's file store.
  fileId: z.string().uuid().nullable().optional(),
  paidDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).nullable().optional(),
  paymentMethod: expensePaymentMethodSchema.nullable().optional(),
  checkNumber: z.string().nullable().optional(),
  reimburse: z.boolean().optional(),
});
